// @flow
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { DataGridPremium, GridActionsCellItem } from "@mui/x-data-grid-premium";
import React, { useMemo } from 'react'
import { CustomPagination } from "../../../../components/mui/grids/dataGridCustom/customPagination";
import { muiGridLocales } from "../../../../helpers/mui/muiLocales";
import useUserData from "../../../../hooks/user/useUserData";
import MUITabs from "./tabs";

type Props = {};

const data = [
	{
		id: 1,
		Name: 'Name 1',
		Description: 'Description 1',
		value: 100,
		isActive: true,
	},
	{
		id: 2,
		Name: 'Name 2',
		Description: 'Description 2',
		value: 200,
		isActive: false,
	},
	{
		id: 3,
		Name: 'Name 3',
		Description: 'Description 3',
		value: 300,
		isActive: true,
	},
	{
		id: 4,
		Name: 'Name 4',
		Description: 'Description 4',
		value: 400,
		isActive: false,
	},
	{
		id: 5,
		Name: 'Name 5',
		Description: 'Description 5',
		value: 500,
		isActive: true,
	},
	{
		id: 6,
		Name: 'Name 6',
		Description: 'Description 6',
		value: 600,
		isActive: false,
	},
	{
		id: 7,
		Name: 'Name 7',
		Description: 'Description 7',
		value: 700,
		isActive: true,
	},
	{
		id: 8,
		Name: 'Name 8',
		Description: 'Description 8',
		value: 800,
		isActive: false,
	},
	{
		id: 9,
		Name: 'Name 9',
		Description: 'Description 9',
		value: 900,
		isActive: true,
	},
	{
		id: 10,
		Name: 'Name 10',
		Description: 'Description 10',
		value: 1000,
		isActive: false,
	},
];


const Others = (props: Props) => {
	const {language} = useUserData()
	const locales = useMemo(() => (muiGridLocales(language)))
	
	const columns = useMemo(() => [
		{
			field: 'Name',
			headerName: 'Name',
			flex: 1,
			minWidth: 140,
			renderCell: (params) => {
				if (params.rowNode.type === 'group') {
					return params.value
				}
				return (
					<Button
						variant={'link'}
						onClick={() => {
						
						}}
					>
						{params.value}
					</Button>
				)
			},
		},
		{
			field: 'Description',
			headerName: 'Description',
			minWidth: 120,
			flex: 1,
		},
		{
			field: 'value',
			headerName: 'Value',
			minWidth: 80,
			flex: 1,
			type: 'numeric'
		},
		{
			field: 'isActive',
			headerName: 'Active',
			minWidth: 80,
			flex: 1,
			type: 'boolean',
		},
		{
			field: 'actions',
			headerName: '',
			width: 80,
			type: 'actions',
			renderCell: (row) => {
				return(
					[
						<GridActionsCellItem
							icon={<EditIcon/>}
							label={'Edit'}
							color={'info'}
						/>
					]
				)
			}
		},
	], [])
	
	
	return (
		<>
			<MUITabs/>
			<Divider/>
			<DataGridPremium
				columns={columns}
				initialState={{ density: "compact" }}
				rows={data}
				localeText={locales}
				slots={{
					pagination: CustomPagination,
					headerFilterMenu: null,
				}}
				headerFilters
				pagination
				pageSizeOptions={[5, 10, 15, 20, 50, 100]}
			/>
		</>
	)
}

export default Others